module.exports = __webpack_public_path__ + "img/97.8.b303ad02.png";